import React, { useState } from 'react'
import { first, map, slice } from 'lodash'

import RightArrow from '../../assets/icons/gallery-arrow-right.svg'
import GalleryModal from './GalleryModal'
import labels from '../../configuration/labels'

import '../../styles/scss/elements/gallery.scss'

const Gallery = ({ isLeonardoPhotos, itineraryFlag, photos }) => {
  const [isModalOpen, setIsModalOpen] = useState(false)

  if (!photos) return null
  const mainPhoto = first(photos)
  const featuredPhotos = slice(photos, 1, 3)

  if (featuredPhotos.length < 2 && mainPhoto) {
    return (
      <div className="gallery-container">
        <div className="photo-main-wrapper">
          {itineraryFlag && (
            <div className="itinerary-flag-banner">
              <span>
                {itineraryFlag}
              </span>
            </div>
          )}
          <img
            className="photo-main"
            src={mainPhoto?.url}
            alt={mainPhoto?.caption}
          />
          {isLeonardoPhotos && <span className="photo-source">{labels.galleryImageSource}</span>}
        </div>
      </div>
    )
  }

  return (
    <div className="gallery-container">
      <div className="photo-main-wrapper">
        {itineraryFlag && (
          <div className="itinerary-flag-banner">
            <span>
              {itineraryFlag}
            </span>
          </div>
        )}
        <img
          className="photo-main"
          src={mainPhoto?.url}
          alt={mainPhoto?.caption}
        />
        {isLeonardoPhotos && <span className="photo-source">{labels.galleryImageSource}</span>}
      </div>
      <div className="photos-featured">
        {map(featuredPhotos, (featuredPhoto, index) => {
          return index < featuredPhotos.length - 1 ? (
            <img
              key={index}
              className="photo-featured"
              src={featuredPhoto?.url}
              alt={featuredPhoto?.caption}
            />
          ) : (
            <div key={index} className="photo-featured-wrapper">
              <img
                key={index}
                className="photo-featured overlay"
                src={featuredPhoto?.url}
                alt={featuredPhoto?.caption}
              />
              <div
                className="photo-featured-overlay"
                style={{ zIndex: isModalOpen ? 0 : 2 }}
              ></div>
              <button
                className="btn-more-photos"
                onClick={() => setIsModalOpen(true)}
                style={{ zIndex: isModalOpen ? 0 : 3 }}
              >
                <span>{labels.galleryMorePhotos}</span>
                <img src={RightArrow} alt={labels.galleryMorePhotos} />
              </button>
              <GalleryModal
                photos={photos}
                isModalOpen={isModalOpen}
                closeModal={() => setIsModalOpen(false)}
              />
            </div>
          )
        })}
      </div>
    </div>
  )
}

export default Gallery
